export default class NotificationFrequencies {
    static frequencies = [
        {
            label : 'Hourly',
            value : 'hourly'
        },
        {
            label : 'Daily',
            value : 'daily'
        },
        {
            label : 'Weekly',
            value : 'weekly'
        }
    ]

    static label(value) {
        return NotificationFrequencies.frequencies.find(level => level.value === (value ?? 'daily'))?.label;
    }
}